<template>
  <div>
    <side-bar
      :menus="menus"
    />
    <div class="page">
      <router-view
      />
    </div>
  </div>
</template>
<script>
  import SideBar from '@/components/layouts/SideBar';

  export default {
    data() {
      return {
        menus: [
          {
            icon :'fa fa-cog',
            label : '계정정보 설정',
            routeName: 'my-page.account.index',
            super: false
          }
        ]
      }
    },
    components: {
      SideBar
    }
  }
</script>
